import {HttpClient} from '@angular/common/http';
import {Injectable} from '@angular/core';

export class ContactData {
    firstName: string;
    lastName: string;
    email: string;
    phone: string;
    teamSize: string;
    industry: string;
    subject: string;
    message: string;
}

@Injectable({
    providedIn: 'root',
})
export class ContactService {
    constructor(private http: HttpClient) {}

    submit(contactData: ContactData) {
        const url = '/api/contact/';
        const options = Object.assign({}, contactData);
        options['withCredentials'] = true;

        return this.http.post(url, options);
    }
}
